import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

const NIVELES = ['A1','A2','B1','B2','C1','C2']
const COLORES_NIVEL = {
  A1:'#22C55E', A2:'#3B82F6', B1:'#8B5CF6',
  B2:'#F59E0B', C1:'#EF4444', C2:'#1B3A8C'
}
const EMOJIS_NIVEL = {
  A1:'🌱', A2:'🚀', B1:'⚡', B2:'🔥', C1:'💎', C2:'👑'
}
const MEDALLAS = { 1:'🥇', 2:'🥈', 3:'🥉' }

const TX = {
  es: {
    tu: '← Tu', lecciones: 'lecciones', examenes: 'examenes', insignias: 'insignias', puntos: 'puntos', pts: 'pts',
    titulo: 'Ranking EspañolGo', subtitulo: 'Compite con otros estudiantes. Los puntos se ganan con lecciones, examenes e insignias.',
    tuPosicion: 'Tu posicion actual', puesto: 'Puesto', tusPuntos: 'Tus puntos',
    global: '🌎 Global', porNivel: '🎯 Por nivel', semana: 'Esta semana', mes: 'Este mes', historico: 'Historico',
    comoPuntos: '¿Como se calculan los puntos?', pLec: '📚 Lecciones: 1 punto por XP ganado',
    pExa: '📝 Examen aprobado: +500 puntos', pIns: '🏅 Insignia ganada: +300 puntos', pRet: '🔥 Reto completado: +200 puntos',
    vacio: 'No hay datos de ranking aun.'
  },
  en: {
    tu: '← You', lecciones: 'lessons', examenes: 'exams', insignias: 'badges', puntos: 'points', pts: 'pts',
    titulo: 'EspañolGo Leaderboard', subtitulo: 'Compete with other students. Points are earned with lessons, exams and badges.',
    tuPosicion: 'Your current position', puesto: 'Rank', tusPuntos: 'Your points',
    global: '🌎 Global', porNivel: '🎯 By level', semana: 'This week', mes: 'This month', historico: 'All time',
    comoPuntos: 'How are points calculated?', pLec: '📚 Lessons: 1 point per XP earned',
    pExa: '📝 Passed exam: +500 points', pIns: '🏅 Badge earned: +300 points', pRet: '🔥 Challenge completed: +200 points',
    vacio: 'There is no leaderboard data yet.'
  }
}

function getIniciales(email) {
  if (!email) return '?'
  return email[0].toUpperCase()
}

function getColorAvatar(email) {
  const colores = ['#7C3AED','#1B3A8C','#059669','#F59E0B','#EF4444','#3B82F6','#EC4899']
  let sum = 0
  for (let c of (email || '')) sum += c.charCodeAt(0)
  return colores[sum % colores.length]
}

function FilaRanking({ entrada, puesto, usuarioId, periodo, t }) {
  const esTuPuesto = entrada.usuario_id === usuarioId
  const medalla = MEDALLAS[puesto]

  return (
    <div style={{
      display:'flex', alignItems:'center', gap:14, padding:'12px 16px',
      background: esTuPuesto ? '#EDE9FE' : puesto <= 3 ? '#FFFBEB' : '#fff',
      border:'1.5px solid ' + (esTuPuesto ? '#7C3AED' : puesto <= 3 ? '#F59E0B33' : '#E2E6F0'),
      borderRadius:12, transition:'all .15s ease',
      boxShadow: esTuPuesto ? '0 0 0 3px rgba(124,58,237,0.15)' : 'none'
    }}>
      <div style={{ width:36, textAlign:'center', flexShrink:0 }}>
        {medalla
          ? <span style={{ fontSize:22 }}>{medalla}</span>
          : <span style={{ fontSize:15, fontWeight:800, color: esTuPuesto ? '#7C3AED' : '#6B7280' }}>#{puesto}</span>
        }
      </div>

      <div style={{ width:38, height:38, borderRadius:'50%', background: getColorAvatar(entrada.email),
        display:'flex', alignItems:'center', justifyContent:'center', fontSize:16, fontWeight:800, color:'#fff', flexShrink:0 }}>
        {getIniciales(entrada.email)}
      </div>

      <div style={{ flex:1, minWidth:0 }}>
        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:2 }}>
          <span style={{ fontSize:14, fontWeight: esTuPuesto ? 800 : 600, color: esTuPuesto ? '#7C3AED' : '#1A1A2E',
            overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
            {entrada.email?.split('@')[0]}
            {esTuPuesto && <span style={{ fontSize:11, marginLeft:6, color:'#7C3AED' }}>{t.tu}</span>}
          </span>
          <span style={{ background: COLORES_NIVEL[entrada.nivel_actual] || '#6B7280', color:'#fff',
            fontSize:10, fontWeight:800, padding:'1px 6px', borderRadius:999, flexShrink:0 }}>
            {entrada.nivel_actual} {EMOJIS_NIVEL[entrada.nivel_actual]}
          </span>
        </div>
        <div style={{ display:'flex', gap:12, fontSize:11, color:'#6B7280' }}>
          <span>📚 {entrada.lecciones_completadas || 0} {t.lecciones}</span>
          <span>📝 {entrada.examenes_aprobados || 0} {t.examenes}</span>
          <span>🏅 {entrada.insignias_ganadas || 0} {t.insignias}</span>
        </div>
      </div>

      <div style={{ textAlign:'right', flexShrink:0 }}>
        <div style={{ fontSize:18, fontWeight:900, color: esTuPuesto ? '#7C3AED' : puesto <= 3 ? '#F59E0B' : '#1A1A2E' }}>
          {periodo === 'semana'
            ? (entrada.puntos_semana || 0).toLocaleString()
            : periodo === 'mes'
            ? (entrada.puntos_mes || 0).toLocaleString()
            : (entrada.puntos_total || 0).toLocaleString()
          }
        </div>
        <div style={{ fontSize:11, color:'#9CA3AF' }}>{t.puntos}</div>
      </div>
    </div>
  )
}

export default function Ranking({ usuario, idioma = 'es' }) {
  const t = TX[idioma] || TX.es
  const [rankingGlobal, setRankingGlobal] = useState([])
  const [rankingNivel,  setRankingNivel]  = useState([])
  const [cargando,      setCargando]      = useState(true)
  const [vista,         setVista]         = useState('global')
  const [periodo,       setPeriodo]       = useState('historico')
  const [nivelFiltro,   setNivelFiltro]   = useState('A1')

  useEffect(() => { cargarDatos() }, [nivelFiltro])

  async function cargarDatos() {
    setCargando(true)
    try {
      const [globalRes, nivelRes] = await Promise.all([
        axios.get(API + '/curriculo/ranking/global'),
        axios.get(API + '/curriculo/ranking/nivel/' + nivelFiltro)
      ])
      setRankingGlobal(globalRes.data.datos || [])
      setRankingNivel(nivelRes.data.datos || [])
    } catch (err) { console.error(err) }
    finally { setCargando(false) }
  }

  const datos = vista === 'global' ? rankingGlobal : rankingNivel

  const getPuesto = (entrada) => {
    if (vista === 'global') {
      if (periodo === 'semana') return entrada.puesto_semana
      if (periodo === 'mes') return entrada.puesto_mes
      return entrada.puesto_historico
    } else {
      if (periodo === 'semana') return entrada.puesto_nivel_semana
      if (periodo === 'mes') return entrada.puesto_nivel_mes
      return entrada.puesto_nivel_historico
    }
  }

  const datosSorted = [...datos].sort((a, b) => getPuesto(a) - getPuesto(b))
  const miPuesto = datosSorted.find(e => e.usuario_id === usuario?.id)
  const miPuestoNum = miPuesto ? getPuesto(miPuesto) : null
  const top3 = datosSorted.slice(0, 3)

  if (cargando) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', padding:60, color:'#6B7280' }}>
      <div style={{ width:32, height:32, border:'3px solid #E2E6F0', borderTopColor:'#F59E0B', borderRadius:'50%', animation:'spinner .8s linear infinite' }} />
    </div>
  )

  return (
    <div style={{ maxWidth:800, margin:'0 auto', animation:'fadeIn .3s ease both' }}>

      {/* Header */}
      <div style={{ background:'linear-gradient(135deg,#92400E,#F59E0B)', borderRadius:16, padding:24, marginBottom:24, color:'#fff' }}>
        <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16 }}>
          <span style={{ fontSize:36 }}>🏆</span>
          <div>
            <h1 style={{ fontSize:22, fontWeight:800, marginBottom:2 }}>{t.titulo}</h1>
            <p style={{ fontSize:13, opacity:.85 }}>{t.subtitulo}</p>
          </div>
        </div>

        {/* Mi puesto destacado */}
        {miPuestoNum && (
          <div style={{ background:'rgba(255,255,255,0.15)', borderRadius:12, padding:'12px 16px', display:'flex', alignItems:'center', gap:12 }}>
            <span style={{ fontSize:28 }}>{MEDALLAS[miPuestoNum] || '🎯'}</span>
            <div>
              <div style={{ fontSize:13, opacity:.8 }}>{t.tuPosicion}</div>
              <div style={{ fontSize:22, fontWeight:900 }}>{t.puesto} #{miPuestoNum}</div>
            </div>
            <div style={{ marginLeft:'auto', textAlign:'right' }}>
              <div style={{ fontSize:13, opacity:.8 }}>{t.tusPuntos}</div>
              <div style={{ fontSize:18, fontWeight:800 }}>
                {periodo === 'semana'
                  ? (miPuesto?.puntos_semana || 0).toLocaleString()
                  : periodo === 'mes'
                  ? (miPuesto?.puntos_mes || 0).toLocaleString()
                  : (miPuesto?.puntos_total || 0).toLocaleString()
                }
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Podio top 3 */}
      {top3.length >= 3 && (
        <div style={{ display:'flex', alignItems:'flex-end', justifyContent:'center', gap:12, marginBottom:28 }}>
          {[top3[1], top3[0], top3[2]].map((entrada, i) => {
            const altura = i === 1 ? 100 : 70
            const puestoReal = i === 0 ? 2 : i === 1 ? 1 : 3
            return (
              <div key={entrada.usuario_id} style={{ textAlign:'center', flex:1 }}>
                <div style={{ fontSize:11, fontWeight:700, color:'#6B7280', marginBottom:4 }}>
                  {entrada.email?.split('@')[0]}
                </div>
                <div style={{ width:48, height:48, borderRadius:'50%', background: getColorAvatar(entrada.email),
                  display:'flex', alignItems:'center', justifyContent:'center', fontSize:20, fontWeight:800, color:'#fff', margin:'0 auto 8px' }}>
                  {getIniciales(entrada.email)}
                </div>
                <div style={{ height:altura, background: puestoReal===1 ? '#F59E0B' : puestoReal===2 ? '#9CA3AF' : '#CD7F32',
                  borderRadius:'8px 8px 0 0', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', color:'#fff', padding:'8px 4px' }}>
                  <div style={{ fontSize:22 }}>{MEDALLAS[puestoReal]}</div>
                  <div style={{ fontSize:13, fontWeight:800 }}>
                    {periodo === 'semana' ? (entrada.puntos_semana||0).toLocaleString()
                    : periodo === 'mes' ? (entrada.puntos_mes||0).toLocaleString()
                    : (entrada.puntos_total||0).toLocaleString()}
                  </div>
                  <div style={{ fontSize:10, opacity:.8 }}>{t.pts}</div>
                </div>
              </div>
            )
          })}
        </div>
      )}

      {/* Controles */}
      <div style={{ display:'flex', gap:8, marginBottom:16, flexWrap:'wrap' }}>
        <div style={{ display:'flex', background:'#F4F6FA', borderRadius:10, padding:4, gap:2 }}>
          {[
            { id:'global', label:t.global },
            { id:'nivel',  label:t.porNivel }
          ].map(v => (
            <button key={v.id} onClick={() => setVista(v.id)}
              style={{ padding:'7px 16px', borderRadius:8, border:'none', fontFamily:'inherit', fontSize:13, fontWeight:600, cursor:'pointer',
                background: vista===v.id ? '#fff' : 'transparent',
                color: vista===v.id ? '#1A1A2E' : '#6B7280',
                boxShadow: vista===v.id ? '0 1px 4px rgba(0,0,0,0.1)' : 'none' }}>
              {v.label}
            </button>
          ))}
        </div>

        <div style={{ display:'flex', background:'#F4F6FA', borderRadius:10, padding:4, gap:2 }}>
          {[
            { id:'semana',    label:t.semana },
            { id:'mes',       label:t.mes },
            { id:'historico', label:t.historico }
          ].map(p => (
            <button key={p.id} onClick={() => setPeriodo(p.id)}
              style={{ padding:'7px 14px', borderRadius:8, border:'none', fontFamily:'inherit', fontSize:12, fontWeight:600, cursor:'pointer',
                background: periodo===p.id ? '#F59E0B' : 'transparent',
                color: periodo===p.id ? '#fff' : '#6B7280',
                boxShadow: periodo===p.id ? '0 1px 4px rgba(245,158,11,0.3)' : 'none' }}>
              {p.label}
            </button>
          ))}
        </div>

        {vista === 'nivel' && (
          <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
            {NIVELES.map(n => (
              <button key={n} onClick={() => setNivelFiltro(n)}
                style={{ padding:'7px 14px', borderRadius:999, border:'2px solid ' + (nivelFiltro===n ? COLORES_NIVEL[n] : '#E2E6F0'),
                  background: nivelFiltro===n ? COLORES_NIVEL[n] : '#fff',
                  color: nivelFiltro===n ? '#fff' : '#374151',
                  fontFamily:'inherit', fontSize:12, fontWeight:700, cursor:'pointer' }}>
                {n} {EMOJIS_NIVEL[n]}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Como se calculan los puntos */}
      <div style={{ background:'#F5F3FF', border:'1px solid #DDD6FE', borderRadius:12, padding:'12px 16px', marginBottom:16 }}>
        <div style={{ fontSize:12, fontWeight:700, color:'#7C3AED', marginBottom:6 }}>{t.comoPuntos}</div>
        <div style={{ display:'flex', gap:16, flexWrap:'wrap', fontSize:12, color:'#6B7280' }}>
          <span>{t.pLec}</span>
          <span>{t.pExa}</span>
          <span>{t.pIns}</span>
          <span>{t.pRet}</span>
        </div>
      </div>

      {/* Lista ranking */}
      <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
        {datosSorted.length === 0 ? (
          <div style={{ textAlign:'center', padding:60, color:'#6B7280' }}>
            <div style={{ fontSize:48, marginBottom:12 }}>🏆</div>
            <p>{t.vacio}</p>
          </div>
        ) : (
          datosSorted.map(entrada => (
            <FilaRanking
              key={entrada.usuario_id}
              entrada={entrada}
              puesto={getPuesto(entrada)}
              usuarioId={usuario?.id}
              periodo={periodo}
              t={t}
            />
          ))
        )}
      </div>
    </div>
  )
}
